import type { TenantId, TenantThemeDefinition } from "../core/types.ts";
import { biblTenantTheme } from "./bibl/index.ts";
import { defaultTenantTheme } from "./default/index.ts";
import { zuuTenantTheme } from "./zuu/index.ts";

export const tenantThemeRegistry: Record<TenantId, TenantThemeDefinition> = {
  default: defaultTenantTheme,
  bibl: biblTenantTheme,
  zuu: zuuTenantTheme,
};

export function getTenantThemeDefinition(
  tenantId?: TenantId
): TenantThemeDefinition {
  if (tenantId && tenantId in tenantThemeRegistry) {
    return tenantThemeRegistry[tenantId];
  }

  return tenantThemeRegistry.default;
}

